<form
  #form="ngForm"
  novalidate
  data-ping-host
>
  @if (stockStore.vm().inUseTanks?.length) {
    <div id="tanksInUseStock">
      <h3 class="text-md pb-4 font-bold">In Use</h3>
      <re-stock-table
        [tabId]="tabId"
        [sectionId]="sectionId"
        [data]="stockStore.vm().inUseTanks"
        [fieldId]="fieldId"
        [columns]="columns"
        [required]="true"
        class="pb-4"
      ></re-stock-table>
    </div>
  }
</form>
